import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff735f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "time" }

import { storeToRefs } from 'pinia';
import { useInfo } from '@/store';
import { Status } from '@/types/enums';
import { isPC } from '@/hooks/useCheck';
import { formatDate } from '@/hooks/useTransformTime';
import { deepLink as utilsDeepLink, checkDevice } from '@/utils/game';

export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleItemText',
  props: {
    className: null,
    title: null,
    startTime: null,
    endTime: null,
    status: null,
    deeplink: null
  },
  setup(__props: any) {


const { googlePlay, appleStore, officialWebsite } = storeToRefs(useInfo());
const goDeepLink = (deepLink: string) => {
  const client = checkDevice();
  let redirectLink = officialWebsite.value;

  switch (client) {
    case 'ios':
      redirectLink = appleStore.value;
      break;
    case 'android':
      redirectLink = googlePlay.value;
      break;
    default:
      break;
  }
  utilsDeepLink(deepLink, () => (window.location.href = redirectLink));
};
const { getImg } = useInfo();
const shareArrow = getImg('anniversary_mobile_share');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'text',
      __props.className,
      {
        disable: __props.status === _unref(Status).Close,
      },
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goDeepLink(__props.deeplink)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
      (__props.status === _unref(Status).Open && !_unref(isPC))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(shareArrow) || '',
            class: "icon-arrow"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("time", _hoisted_4, _toDisplayString(_unref(formatDate)(__props.startTime)) + " - " + _toDisplayString(_unref(formatDate)(__props.endTime)), 1)
  ], 2))
}
}

})